import React, { Component } from 'react';
import isExpired from '../src/utils/checkToken';
import { Router } from '../routes';

import { redirectIfNotSubscribed, redirectIfSubscribed, redirectIfNotAuthenticated, getJwt } from '../src/lib/auth';
import { getCurrentUser } from '../src/services/userApi';

class Index extends Component {

	static async getInitialProps(ctx) {
		if(redirectIfNotAuthenticated(ctx)) {
			return {};
		}
		const jwt = getJwt(ctx);
		const res = await getCurrentUser(jwt);
		const { user } = res.data;
		if(redirectIfNotSubscribed(ctx, user)) {
			return {};
		}
		if(redirectIfSubscribed(ctx, user)) {
			return {};
		}
		return {
			title: 'Perfect Tense | Home',
			user,
			authenticated: !!jwt
		};
	}

	render() {
		console.log(this.props);
		return (
			<div>
				Welcome to Perfect Tense!
			</div>
		);
	}
}

export default Index;


// WEBPACK FOOTER //
// ./pages/index.js